import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid';

import InputControl from '~/components/Input/InputControl';
import InputNumber from '~/components/Input/InputNumber';

import { editFilter } from '../../../../store/actions';

function InputNumeric(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    column,
    filter,
    indexGroup,
    indexFilter,
    inputProps,
    ...ownProps
  } = props;

  if (filter.get('operation') === 'between') {
    const value = filter.get('value');
    const [start = '', end = ''] = typeof value === 'string' ? value.split('|') : '';
    // const [start = '', end = ''] = filter.get('value').split('|');

    return (
      <Grid container justify="space-between" spacing={1}>
        <Grid item xs={6}>
          <InputControl
            value={start}
            name={'start'}
            inputComponent={InputNumber}
            InputProps={{
              placeholder: t('filter-label-value-start'),
              precision: column.precision,
              showMask: false,
              ...inputProps,
            }}
            onChange={({ start }) => dispatch(editFilter(indexGroup, indexFilter, 'value', `${start}|${end}`))}
            {...ownProps}
            autoComplete={false}
          />
        </Grid>
        <Grid item xs={6}>
          <InputControl
            value={end}
            name={'end'}
            inputComponent={InputNumber}
            InputProps={{
              placeholder: t('filter-label-value-end'),
              precision: column.precision,
              showMask: false,
              ...inputProps,
            }}
            onChange={({ end }) => dispatch(editFilter(indexGroup, indexFilter, 'value', `${start}|${end}`))}
            {...ownProps}
            autoComplete={false}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <InputControl
      value={filter.get('value')}
      name={'value'}
      inputComponent={InputNumber}
      InputProps={{
        placeholder: t('filter-label-value'),
        precision: column.precision,
        showMask: false,
        ...inputProps,
      }}
      onChange={({ value }) => dispatch(editFilter(indexGroup, indexFilter, 'value', value))}
      {...ownProps}
      autoComplete={false}
    />
  );
}

export default React.memo(InputNumeric);
